import { useEffect, useState } from 'react';
import { privateImageCache } from '@ff-os/rendering-react/asset-loading/privateImageCache';
import { isDescriptor } from '@ff-os/shared-utils/private-urls';

/**
 * Returns a URL suitable for use in <code>&lt;img src="..." /&gt;</code>. If
 * the asset URL is private (and thus requires auth headers), it will be
 * loaded asynchronously into a blob URL first.
 */
export const useImageSrc = (assetUrl: string | undefined) => {

    const [url, setUrl] = useState<string | undefined>();

    useEffect(() => {

        let mounted = true;

        if (!assetUrl) {
            setUrl(undefined);
            return () => {
                mounted = false;
            };
        }

        if (isDescriptor(assetUrl)) {
            const entry = privateImageCache.require(assetUrl);
            entry.promise.then(result => {
                if (mounted) {
                    setUrl(result);
                }
            });
        } else {
            setUrl(assetUrl);
        }

        return () => {
            mounted = false;
        };
    }, [assetUrl]);

    return assetUrl && url;
};